import { callApiByPath } from "@src/api/axios";
import * as React from "react";
import Form, { FormProps } from "zq-ui-v3/components/Form/Form";
import cookie from "react-cookies";
import { History } from "history";
import View from "zq-ui-v3/components/View/View";

// import { useContext } from "../../lib/hooks/useAdminContext";
// import { useDispatch } from "react-redux";
// import { socketClose, socketConnect, updateProfile } from "@src/redux/actions";
// import { useHistory } from "react-router";

interface LoginProps extends FormProps {
  history?: History<unknown>;
}

const Login: React.FC<LoginProps> = ({ ...rest }) => {
  // const { setOpenLogin } = useContext();
  // const dispatch = useDispatch();
  // const history = useHistory();

  const handleSubmit = async (data) => {
    let deviceId = localStorage.getItem("deviceId");
    if (!deviceId) {
      deviceId = cookie.load("deviceId");
    }

    const re: any = await callApiByPath("post", "/account/User/login", { ...data, deviceId });
    sessionStorage.setItem("token", re.token);
    // dispatch(updateProfile(re));
    // dispatch(socketClose());
    // dispatch(socketConnect());

    // deviceId = cookie.save(tokenKey, re.token);
    // setOpenLogin(false);
    rest.onClose();
    // eslint-disable-next-line no-self-assign
    localStorage.setItem("loginName", re.loginName);
    window.location.reload();
    // window.location.href = window.location.href;
  };
  return (
    <>
      {rest.open && (
        <View
          className="position-fixed position-full"
          style={{ backgroundColor: "cadetblue", zIndex: 2 }}
        />
      )}
      <Form
        title="登录系统"
        {...rest}
        dialogProps={{
          open: rest.open,
          maxWidth: "xs",
          fullWidth: true,
          disableBackdropClick: true,
          disableEscapeKeyDown: true,
          hideCloseBtn: true,
          hideFullBtn: true,
        }}
        submitBtnText="登录"
        onSubmit={handleSubmit}
        mdataList={[
          { name: "phone", title: "手机号码", isNotNull: true },
          { name: "password", title: "密码", inputType: "password", isNotNull: true },
        ]}
      />
    </>
  );
};
export default Login;
